import DialogComponent from '../components/shared/dialog-component.vue';
import Vue from 'vue';

const SELECTOR = '.js-confirm';

class FormConfirm {
    constructor(element, { message = 'Czy jesteś pewien?' }) {
        this.vm = this.createComponent({ message });
        element.addEventListener('submit', this.eventHandler.bind(this));
    }

    eventHandler(event) {
        this.vm.visible = true;

        this.vm.$on('confirm', () => {
            this.vm.visible = false;
            event.target.submit();
        });

        this.vm.$on('cancel', () => {
            this.vm.visible = false;
        });

        event.preventDefault();
    }

    createComponent(data) {
        var frag = document.createElement('div');
        document.body.appendChild(frag);

        return new Vue({
            components: {
                'dm-dialog' : DialogComponent
            },
            template: `
                <dm-dialog v-if="visible" v-on:confirm="$emit('confirm')" v-on:cancel="$emit('cancel')" :title="title">
                    <div class="_tac">
                        Czy jesteś pewien? 
                    </div>
                </dm-dialog>
            `,
            el: frag,
            data() {
                return {
                    visible: false,
                    title: data.message,
                    content: data.content
                };
            }
        });
    }
}

[].forEach.call(document.querySelectorAll(SELECTOR), item => new FormConfirm(item, {
    message: 'Potwierdź usunięcie konta'
}));

export default FormConfirm; 
